import PropTypes from 'prop-types';

const featureShape = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
  description: PropTypes.string,
};

featureShape.features = PropTypes.arrayOf(PropTypes.shape(featureShape));

export const featurePropTypes = PropTypes.shape(featureShape);
